import { CaretRightOutlined, CheckCircleTwoTone, CloseCircleOutlined, CloseCircleTwoTone, ShopOutlined } from '@ant-design/icons';
import { Divider, Drawer, Tag, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../../../hooks/useFetch/useFetch';
import { LOGSTYPES } from '../../../../../common/constants/logsTypes';
import moment from 'moment';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { LocationModal } from './LocationModal';
import { ButtonLZ } from '../../../../components/design/Buttons/ButtonLZ';
import { DrawerPanelTitle, drawerPanelStyles } from '../../Drawers/DrawerPanelTitle';


export const Operations = (props: {job : any, onFinish: any}) => {

  const { t } = useTranslation();
  const [updateData, setUpdateData] = useState(false);
  const [successList, setSuccessList] = useState([]);
  const [errorList, setErrorList] = useState([]); 
  const [locationModal, setlocationModal] = useState(null);  
  const { projectGroup } = useAuth();

  const { isLoading } = useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/jobs/' + props.job.id + '/operations', {}, [updateData], (data) => {
		setSuccessList(data.success);
		setErrorList(data.error);    
	});

  return (
          <Drawer            
            title={<DrawerPanelTitle title="Operación" />}
            width={'40%'}
            {...drawerPanelStyles}
            onClose={props.onFinish}
            open={true}
          >
          <div style={{background:'white', padding:'15px'}}>
            <div><b>{props.job.action}</b></div>
            <div>#{props.job.operations} locales</div>
            <small style={{color:'grey'}}>{moment(props.job.created).format('ll')}</small>
          </div> 
          <br/>
          <Tag color="green">{t('dictionary.correct.plural.female')}: {successList.length}</Tag>
          <Tag color="red">{t('dictionary.errors')}: {errorList.length}</Tag> 
          <br/>
          <Divider orientation="left">Por local</Divider>
          {
            errorList && errorList.map((errorItem : any) => {
              return (
                <Tooltip overlay={errorItem.tooltip ? errorItem.tooltip : null}>
                    <span style={{color:'MediumVioletRed'}}>
                      <CloseCircleOutlined color="MediumVioletRed" style={{ paddingRight: '5px' }} />
                      {errorItem.message}
                    </span>
                    {errorItem.locationId &&
                      <ButtonLZ type='link' onClick={() => {setlocationModal(errorItem.locationId);}} size='small'>    
                        Ver local
                      </ButtonLZ>						
                    }
                  </Tooltip>
              )           
            })
          }
          {
            successList && successList.map((succesItem : any) => {
              return (
                <Tooltip overlay={succesItem.tooltip ? succesItem.tooltip : null}>
                    <div>
                      <CheckCircleTwoTone twoToneColor="#52c41a" style={{paddingRight:'5px'}}/>                  
                      {succesItem.message}
                    </div>
                    {succesItem.link &&  (<><CaretRightOutlined style={{paddingLeft:'25px'}} />
                    <a href={succesItem.link} target={'_blank'}> {(succesItem.type !== LOGSTYPES.PHOTO_COVER || succesItem.type !== LOGSTYPES.PHOTO_LOGO) ? t('dictionary.postLink') : t('dictionary.googleLink')}</a>
                    </>)}                  
                </Tooltip>
              )
            })
          }
         
         {locationModal && (
           <LocationModal
             locationId={locationModal}             
             onFinish={() => {
               setlocationModal(null);               
             }}             
           />)
         }		
          </Drawer>

	)
}

